import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import actions from "actions";
import { UserList } from "components/Admin/User/List/UserList.jsx";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import Toolbar from "components/Admin/User/Toolbar";

const { showDeleteUsersConfirmationModal, adminUserFilter } = actions;

const roles = [
  { value: "gp", label: "GP" },
  { value: "gp_trainee", label: "GP Trainee" },
  { value: "nurse", label: "Nurse" },
  { value: "consultant", label: "Consultant" },
  { value: "hospital_doctor", label: "NCHD (Hospital Doctor)" },
  { value: "nurse_specialist", label: "Nurse Specialist/ANP" },
  {
    value: "allied_healthcare_professional",
    label: "Allied Healthcare Professional",
  },
  { value: "pharmacist", label: "Pharmacy" },
  // { value: "midwifery", label: "Midwife" },
  // { value: 'practice_nurses_ipna_member', label: 'IGPNEA Members'}
];

class Users extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.timer = true;
    this.state = {
      user_ids: [],
      page: props.page || 1,
      searchQuery: {
        order: {
          created_at: "desc",
        },
        ...props.query,
      },
      startDate: null,
      endDate: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.total_pages != this.props.total_pages)
      this.setState({
        page: 1,
      });
  }

  componentWillMount = () => {
    this.updateUsersList();
  };

  deleteUsers = () => {
    if (this.state.user_ids.length > 0)
      this.props.deleteUsers(this.state.user_ids);
  };

  onChangePage = (page = 1) => {
    this.setState(
      {
        page,
      },
      this.updateUsersList
    );
  };

  onOrderChange = (field = "created_at", order = "desc") => {
    const searchQuery = {
      ...this.state.searchQuery,
      order: {
        [field]: order,
      },
    };
    this.setState(
      {
        searchQuery,
      },
      this.updateUsersList
    );
  };

  checkedUserIds = (user_id) => {
    var ids = _.assign(this.state.user_ids),
      index = this.state.user_ids.indexOf(user_id);

    if (index == -1) {
      ids.push(user_id);
    } else {
      ids.splice(index, 1);
    }
    this.setState({ user_ids: ids });
  };

  changeFilterQuery = (field, value) => {
    const query = { ...this.state.searchQuery, ...{ [field]: value } };
    this.setState({ searchQuery: query, page: 1 }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.updateUsersList, 500);
    });
  };

  onDateRangeChange = (field, start, end) => {
    const query = {
      ...this.state.searchQuery,
      ...{ [`${field}_from`]: start, [`${field}_to`]: end },
    };
    this.setState({ searchQuery: query, page: 1 }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.updateUsersList, 500);
    });
  };

  updateUsersList = () => {
    const { page, searchQuery } = this.state;
    this.props.userFilter(searchQuery, page);
  };

  render() {
    const { changeFilterQuery, setState, deleteUsers, onDateRangeChange } =
      this;
    return (
      <main className="site--width container_statistics">
        <Toolbar
          filterProps={{
            ...this.state,
            changeFilterQuery,
            setState,
            roles,
            onDateRangeChange,
          }}
          toolsProps={{
            deleteUsers,
            count: this.props.count,
          }}
        />
        <div className="admin_user_table admin_table">
          <UserList
            onOrderChange={this.onOrderChange}
            query={this.state.searchQuery}
            users={this.props.users}
            checkedUserIds={this.checkedUserIds}
            user_ids={this.state.user_ids}
            paginationProps={{
              onChangePage: this.onChangePage,
              page: this.state.page,
              total_pages: this.props.total_pages,
            }}
          />
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    users: state.users.adminUsers.values,
    count: state.users.adminUsers.count,
    total_pages: state.users.adminUsers.total_pages,
    page: state.users.adminUsers.page,
    query: state.users.adminUsers.query,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    deleteUsers: (user_ids) =>
      dispatch(showDeleteUsersConfirmationModal(user_ids)),
    userFilter: (query, page) => dispatch(adminUserFilter(query, page)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);



// WEBPACK FOOTER //
// ./src/containers/Admin/User/Users.jsx